import { render, staticRenderFns } from "./DataTableClientSide.vue?vue&type=template&id=65a6bdb0"
import script from "./DataTableClientSide.vue?vue&type=script&lang=js"
export * from "./DataTableClientSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports